var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#505152"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_196335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3287 21.8042C24.3378 21.2041 24.3469 20.5949 24.3378 20.004C24.3378 19.4039 24.3378 18.8038 24.3287 18.1947C24.3014 16.7399 24.3105 14.8943 23.1831 13.776C22.0921 12.685 20.5102 12.5305 19.0191 12.4941C18.3281 12.4759 17.7462 12.4668 17.1645 12.4668C16.5734 12.4668 15.9916 12.4759 15.3097 12.4941C15.146 12.4941 14.9823 12.5032 14.8096 12.5123L24.3287 22.0587V21.8042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8411 15.1398C28.6484 15.1398 28.451 15.1942 28.2645 15.3136L24.8822 17.4804V22.5199L28.2645 24.6865C28.451 24.8059 28.6486 24.8606 28.8412 24.8606C29.4455 24.8606 29.9998 24.3244 29.9998 23.5749V16.4253C29.9998 15.6762 29.4454 15.1398 28.8411 15.1398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0095 11.0112C11.7436 10.744 11.3121 10.744 11.0453 11.0094C10.7785 11.2748 10.7776 11.7064 11.0435 11.9736L12.1406 13.0752C11.7822 13.2472 11.4417 13.4801 11.1456 13.776C10.0182 14.9034 10.0273 16.749 10 18.2038V21.8041C10.0273 23.2588 10.0182 25.1044 11.1456 26.2227C12.2276 27.3138 13.8186 27.4683 15.3097 27.5047C15.9916 27.5229 16.5734 27.532 17.1645 27.532C17.7463 27.532 18.3282 27.5229 19.0191 27.5047C20.5011 27.4683 22.0921 27.3138 23.1831 26.2227C23.5437 25.8621 23.7958 25.4204 23.9598 24.9434L27.9885 28.9888C28.1217 29.1229 28.2966 29.1895 28.4715 29.1895C28.6455 29.1895 28.8195 29.1229 28.9527 28.9906C29.2195 28.7251 29.2204 28.2936 28.9545 28.0264L12.0095 11.0112Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_196335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoh);
export default __webpack_public_path__ + "static/media/videoh.6e0c8902c5aaa6529cf91fece07e3562.svg";
export { ForwardRef as ReactComponent };